import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ExpenseReportFilter } from "../../../../models/expense-reports";
import { EXPENSE_REPORT_STATUS } from "../../../../utils/constants/constants";
import useAuthorization from "../../../../custom-hooks/useAuthorization/useAuthorization";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";
import { useExpenseReportStatusQuickFilter } from "../../../Quickfilters/ExpenseReportStatusQuickfilter";
import useQuery from "../../../../custom-hooks/useQuery/useQuery";
import { LegalEntityQuickfilter, useLegalEntityQuickFilter } from "../../../Quickfilters/LegalEntityQuickfilter";
import { EmployeeGroupQuickfilter, useEmployeeGroupQuickFilter } from "../../../Quickfilters/EmployeeGroupQuickfilter";
import YearPicker from "../../../../reusable-components/YearPicker/YearPicker";
import { ExpenseReportView } from "../../../../views/travel-and-expenses/ExpenseReport/utils";
import ExpenseReport from "../../../../views/travel-and-expenses/ExpenseReport/ExpenseReport";

interface State {
  year: number;
}

const ProjectAssignmentsPendingExpenseReports = () => {
  const { t } = useTranslation();
  const tRP = "components.project_assignment_pending_approvals";

  const [state, setState] = useState<State>({
    year: new Date().getFullYear(),
  });

  const {
    legalEntitiesQuickFilter,
    setLegalEntitiesQuickFilter,
    selectedLegalEntity,
    legalEntityQFIsLoading,
    allLegalEntities,
  } = useLegalEntityQuickFilter(true);
  const { employeeGroupQuickFilter, setEmployeeGroupQuickFilter } = useEmployeeGroupQuickFilter();

  const hasAccess = useAuthorization([
    AUTHORIZATIONS.EmployeesAccess.ApproveExpenses,
    AUTHORIZATIONS.EmployeesAccess.PayExpenses,
  ]);

  const query = useQuery();
  const { expenseReportStatusQuickFilter, setExpenseReportStatusQuickFilter } = useExpenseReportStatusQuickFilter();

  useEffect(() => {
    const open = query.get("open") === "true" ? true : false;

    if (open) {
      setExpenseReportStatusQuickFilter("expenseReportStatuses", {
        expenseReportStatusIds: [EXPENSE_REPORT_STATUS.submitted.id],
      });
    }
  }, [query]);

  return (
    <>
      <Grid>
        {hasAccess && !legalEntityQFIsLoading && (
          <>
            <ExpenseReport
              view={ExpenseReportView.manager}
              tableTitle={`${t(`${tRP}.table_title`)}`}
              propsFilter={
                {
                  legalEntityIds: legalEntitiesQuickFilter.legalEntities?.legalEntityIds,
                  employeeGroupIds: employeeGroupQuickFilter.employeeGroups?.employeeGroupIds,
                  // year: state.year,
                  allStatuses: false,
                } as ExpenseReportFilter
              }
              quickfilters={
                <>
                  <LegalEntityQuickfilter
                    quickFilters={legalEntitiesQuickFilter}
                    handleChangeQuickFilters={setLegalEntitiesQuickFilter}
                    allLegalEntitiesOption
                    allLegalEntities={allLegalEntities}
                  />
                  <EmployeeGroupQuickfilter
                    quickFilters={employeeGroupQuickFilter}
                    handleChangeQuickFilters={setEmployeeGroupQuickFilter}
                    allEmployeeGroupsOption={true}
                  />
                  <YearPicker
                    value={state.year}
                    onChange={(value) => {
                      setState((state) => ({ ...state, year: value }));
                    }}
                  />
                </>
              }
              selectedLegalEntity={selectedLegalEntity}
            />
          </>
        )}
      </Grid>
    </>
  );
};
export default ProjectAssignmentsPendingExpenseReports;
